export default __webpack_public_path__ + "static/media/scheduled-cl.3376303c.svg";